export default "__VITE_ASSET__CZsVUjSt__"